import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withKeys as _withKeys, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-fixed tw-inset-0 tw-z-[60] tw-flex tw-flex-col tw-bg-white tw-text-slate-900"
}
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-4 tw-bg-white tw-border-b tw-border-slate-200" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_4 = { class: "tw-bg-blue-50 tw-p-2.5 tw-rounded-xl" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "tw-h-9 tw-px-3 tw-bg-blue-50 tw-border tw-border-blue-100 tw-rounded-xl tw-text-[10px] tw-font-black tw-text-blue-600 tw-flex tw-items-center tw-gap-2"
}
const _hoisted_7 = { class: "tw-relative" }
const _hoisted_8 = {
  key: 0,
  class: "tw-absolute tw-top-full tw-mt-2 tw-right-0 tw-bg-white tw-border tw-border-slate-200 tw-rounded-xl tw-shadow-lg tw-p-4 tw-z-50 tw-w-72"
}
const _hoisted_9 = { class: "tw-flex tw-items-center tw-gap-2 tw-mb-3" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "tw-mb-3"
}
const _hoisted_12 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "tw-mb-3"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "tw-flex tw-flex-1 tw-min-h-0" }
const _hoisted_18 = {
  style: {"width":"420px"},
  class: "tw-w-85 tw-bg-slate-50 tw-border-r tw-border-slate-200 tw-flex tw-flex-col tw-min-h-0 tw-overflow-y-auto custom-scrollbar"
}
const _hoisted_19 = { class: "tw-p-6 tw-border-b tw-border-slate-200 tw-flex-none tw-text-left" }
const _hoisted_20 = { class: "tw-text tw-font-bold tw-uppercase tw-tracking-widest tw-mb-5" }
const _hoisted_21 = {
  key: 1,
  class: "tw-p-6 tw-flex-none template-reveal-animation tw-shadow-lg tw-rounded-lg tw-w-full tw-relative"
}
const _hoisted_22 = { class: "tw-pr-2" }
const _hoisted_23 = {
  key: 0,
  class: "tw-text-center tw-py-4"
}
const _hoisted_24 = {
  key: 1,
  class: "tw-space-y-3"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "tw-min-w-0 tw-flex-1 tw-flex tw-flex-col tw-justify-center" }
const _hoisted_27 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_28 = { class: "tw-text-xs tw-font-bold tw-truncate tw-text-slate-900 tw-leading-none" }
const _hoisted_29 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-1 tw-px-1.5 tw-py-0.5 tw-bg-blue-50 tw-border tw-border-blue-100 tw-rounded-md tw-shrink-0"
}
const _hoisted_30 = { class: "tw-flex tw-items-center tw-gap-2 tw-mt-1.5" }
const _hoisted_31 = { class: "tw-text-[9px] tw-font-bold tw-px-1.5 tw-py-0.5 tw-bg-slate-100 tw-text-slate-500 tw-rounded tw-uppercase tw-tracking-tight tw-leading-none" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 2,
  class: "tw-p-6 tw-flex-none template-reveal-animation tw-w-full tw-relative"
}
const _hoisted_34 = { class: "tw-relative tw-group" }
const _hoisted_35 = { class: "tw-border-2 tw-border-dashed tw-border-slate-200 tw-bg-white tw-rounded-2xl tw-p-5 tw-text-center group-hover:tw-border-blue-400 tw-transition-colors" }
const _hoisted_36 = { class: "tw-text-[11px] tw-mt-2 tw-font-semibold tw-text-slate-700 tw-truncate" }
const _hoisted_37 = {
  key: 0,
  class: "tw-p-6 tw-border-b tw-border-slate-200 tw-flex-none tw-text-left"
}
const _hoisted_38 = {
  key: 1,
  class: "tw-p-6 tw-border-b tw-border-slate-200 tw-flex-none tw-text-left"
}
const _hoisted_39 = { class: "tw-flex tw-items-center tw-justify-between tw-mb-4" }
const _hoisted_40 = { class: "tw-text-[10px] tw-font-bold tw-text-blue-500 tw-bg-blue-50 tw-px-1.5 tw-py-0.5 tw-rounded" }
const _hoisted_41 = { class: "tw-mb-4" }
const _hoisted_42 = { class: "tw-max-h-[28vh] tw-overflow-y-auto tw-pr-2 custom-scrollbar" }
const _hoisted_43 = { class: "tw-grid tw-grid-cols-1 tw-gap-2.5" }
const _hoisted_44 = ["onClick", "onDragstart"]
const _hoisted_45 = {
  key: 0,
  class: "tw-py-4 tw-text-center"
}
const _hoisted_46 = { class: "tw-flex-1 tw-bg-slate-100 tw-overflow-auto tw-relative tw-flex tw-items-start tw-justify-center tw-p-4 md:tw-p-8 lg:tw-p-12" }
const _hoisted_47 = {
  key: 0,
  class: "tw-mt-20 tw-text-center"
}
const _hoisted_48 = { class: "tw-w-24 tw-h-24 tw-bg-white tw-rounded-[2.5rem] tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-8 tw-shadow-sm tw-border tw-border-slate-200" }
const _hoisted_49 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-items-center tw-w-full tw-min-h-0 tw-relative"
}
const _hoisted_50 = {
  key: 0,
  class: "tw-absolute tw-top-50p tw-left-50p tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2"
}
const _hoisted_51 = {
  ref: "pdfCanvas",
  class: "tw-w-full tw-h-auto"
}
const _hoisted_52 = {
  key: 0,
  class: "grid-overlay"
}
const _hoisted_53 = ["onMousedown", "onClick"]
const _hoisted_54 = { class: "tw-font-bold tw-whitespace-nowrap" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "tw-pl-3 tw-pr-5 tw-border-r tw-border-slate-100" }
const _hoisted_57 = { class: "tw-text-[11px] tw-font-bold tw-text-slate-900 tw-font-mono tw-mt-0.5" }
const _hoisted_58 = {
  key: 0,
  class: "tw-flex-1 tw-flex tw-items-center tw-gap-3 tw-mr-4"
}
const _hoisted_59 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_60 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_61 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_62 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_63 = {
  key: 1,
  class: "tw-sticky tw-bottom-4 tw-z-[60] tw-w-full tw-flex tw-justify-center ttw-pointer-events-none"
}
const _hoisted_64 = { class: "tw-flex tw-items-center tw-gap-2 tw-bg-white tw-px-3 tw-py-1 tw-rounded-xl tw-shadow-lg tw-shadow-slate-900/5 tw-border tw-border-slate-200 tw-pointer-events-auto" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { class: "tw-text-xs tw-font-bold tw-text-slate-600 tw-min-w-[70px] tw-text-center tw-select-none tw-uppercase tw-tracking-wider" }
const _hoisted_67 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_DropdownList = _resolveComponent("DropdownList")!
  const _component_SearchInput = _resolveComponent("SearchInput")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_font_awesome_icon, {
                icon: "file-signature",
                class: "tw-text-blue-600 tw-text-lg"
              })
            ]),
            _cache[46] || (_cache[46] = _createElementVNode("div", null, [
              _createElementVNode("h2", { class: "tw-text-lg tw-font-bold tw-text-slate-900" }, "Document Studio"),
              _createElementVNode("p", { class: "tw-text-[10px] tw-text-slate-500 tw-uppercase tw-font-bold tw-tracking-wider tw-mt-0.5" }, "Template Configuration")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.pdfWidth && _ctx.pdfHeight)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.pdfWidth) + "×" + _toDisplayString(_ctx.pdfHeight), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showGrid = !_ctx.showGrid)),
              class: _normalizeClass([
          'tw-h-9 tw-px-4 tw-rounded-xl tw-text-[10px] tw-font-black tw-uppercase tw-tracking-wider tw-transition-all tw-flex tw-items-center tw-gap-2',
          _ctx.showGrid ? 'tw-bg-slate-900 tw-text-white' : 'tw-bg-slate-200 tw-text-slate-500'
        ])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "border-all",
                  class: _normalizeClass(_ctx.showGrid ? 'tw-text-blue-400' : '')
                }, null, 8, ["class"]),
                _cache[47] || (_cache[47] = _createTextVNode(" Grid ", -1))
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_Button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.snapToGrid = !_ctx.snapToGrid)),
              class: _normalizeClass([
          'tw-h-9 tw-px-4 tw-rounded-xl tw-text-[10px] tw-font-black tw-uppercase tw-tracking-wider tw-transition-all tw-flex tw-items-center tw-gap-2',
          _ctx.snapToGrid ? 'tw-bg-slate-900 tw-text-white' : 'tw-bg-slate-200 tw-text-slate-500'
        ])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.snapToGrid ? 'magnet' : 'link-slash',
                  class: _normalizeClass(_ctx.snapToGrid ? 'tw-text-emerald-400' : '')
                }, null, 8, ["icon", "class"]),
                _createTextVNode(" Snap: " + _toDisplayString(_ctx.snapToGrid ? 'ON' : 'OFF'), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPreviewDropdown = !_ctx.showPreviewDropdown)),
                disabled: !_ctx.currentTemplate?.id || _ctx.saving,
                class: "tw-h-9 tw-px-5 tw-bg-slate-900 tw-text-white tw-rounded-xl tw-text-[10px] tw-font-black tw-uppercase tw-tracking-wider hover:tw-bg-slate-800 disabled:tw-opacity-50 tw-flex tw-items-center tw-gap-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                  _cache[48] || (_cache[48] = _createTextVNode(" Preview ", -1))
                ]),
                _: 1
              }, 8, ["disabled"]),
              (_ctx.showPreviewDropdown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPreviewDropdown = false)),
                      class: "tw-absolute tw-top-2 tw-right-2 tw-ml-2 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-bg-grey-200 tw-rounded-lg hover:tw-bg-grey-800 tw-transition-colors"
                    }, " X "),
                    _cache[52] || (_cache[52] = _createElementVNode("label", { class: "tw-text-[10px] tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider tw-mb-1 tw-block" }, "Order ID", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sampleOrderId) = $event)),
                        type: "number",
                        placeholder: "Enter Order ID",
                        class: "tw-flex-1 tw-h-9 tw-px-3 tw-bg-slate-100 tw-border tw-border-slate-200 tw-rounded-lg tw-text-xs tw-font-semibold tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500"
                      }, null, 512), [
                        [_vModelText, _ctx.sampleOrderId]
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fetchSampleOrder && _ctx.fetchSampleOrder(...args))),
                        disabled: !_ctx.sampleOrderId,
                        class: "tw-h-9 tw-w-9 tw-flex tw-items-center tw-justify-center tw-rounded-lg hover:tw-bg-slate-200 disabled:tw-opacity-50 tw-shrink-0 tw-icon tw-icon-sm"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "magnifying-glass" })
                      ], 8, _hoisted_10)
                    ]),
                    (_ctx.sampleOrder?.containers?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _cache[49] || (_cache[49] = _createElementVNode("label", { class: "tw-text-[10px] tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider tw-mb-1 tw-block" }, "Container", -1)),
                          _createElementVNode("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sampleContainerId) = $event)),
                              class: "tw-flex-1 tw-h-9 tw-px-3 tw-bg-slate-100 tw-border tw-border-slate-200 tw-rounded-lg tw-text-xs tw-font-semibold tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sampleOrder.containers.toSorted((a,b) => a.internalIndex <= b.internalIndex ? -1 : 1), (c, i) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: c.id,
                                  value: c.id
                                }, _toDisplayString(String(c.internalIndex).padStart(2, '0')) + " - " + _toDisplayString(c.containerId), 9, _hoisted_13))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.sampleContainerId]
                            ]),
                            _createElementVNode("button", {
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fetchSampleContainer && _ctx.fetchSampleContainer(...args))),
                              disabled: !_ctx.sampleContainerId,
                              class: "tw-h-9 tw-w-9 tw-flex tw-items-center tw-justify-center tw-rounded-lg hover:tw-bg-slate-200 disabled:tw-opacity-50 tw-shrink-0"
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: "magnifying-glass" })
                            ], 8, _hoisted_14)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.sampleContainer?.trips?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[50] || (_cache[50] = _createElementVNode("label", { class: "tw-text-[10px] tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider tw-mb-1 tw-block" }, "Trip", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.sampleTripId) = $event)),
                            class: "tw-w-full tw-h-9 tw-px-3 tw-bg-slate-100 tw-border tw-border-slate-200 tw-rounded-lg tw-text-xs tw-font-semibold tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedTrips, (t) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: t.id,
                                value: t.id
                              }, " Leg " + _toDisplayString(t.legId) + " - " + _toDisplayString(t.tripType) + " (#" + _toDisplayString(t.id) + ") ", 9, _hoisted_16))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.sampleTripId]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Button, {
                      onClick: _ctx.handlePreview,
                      disabled: !_ctx.sampleOrder || !_ctx.sampleContainer || !_ctx.sampleTripId,
                      class: "tw-w-full tw-h-9 tw-bg-slate-900 tw-text-white tw-rounded-xl tw-text-[10px] tw-font-black tw-uppercase tw-tracking-wider hover:tw-bg-slate-800 disabled:tw-opacity-50 tw-flex tw-items-center tw-justify-center tw-gap-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                        _cache[51] || (_cache[51] = _createTextVNode(" Preview ", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Button, {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleDownloadTemplate())),
              disabled: !_ctx.currentTemplate?.id || _ctx.saving,
              class: "tw-h-9 tw-px-5 tw-bg-slate-900 tw-text-white tw-rounded-xl tw-text-[10px] tw-font-black tw-uppercase tw-tracking-wider hover:tw-bg-slate-800 disabled:tw-opacity-50 tw-flex tw-items-center tw-gap-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "download" }),
                _cache[53] || (_cache[53] = _createTextVNode(" Get PDF ", -1))
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Button, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveDefault())),
              disabled: !_ctx.currentTemplate || _ctx.currentTemplate.isDefault,
              class: _normalizeClass([
          'tw-h-9 tw-px-3 tw-rounded-xl tw-text-[10px] tw-font-black tw-uppercase tw-tracking-wider tw-transition-all tw-flex tw-items-center tw-gap-2',
          _ctx.currentTemplate?.isDefault
            ? 'tw-bg-blue-600/20 tw-text-blue-600 tw-border tw-border-blue-200'
            : 'tw-bg-slate-900 tw-text-white hover:tw-bg-slate-800'
        ])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentTemplate?.isDefault ? 'Current Default' : 'Make Default'), 1)
              ]),
              _: 1
            }, 8, ["disabled", "class"]),
            _createVNode(_component_Button, {
              onClick: _ctx.saveFields,
              loading: _ctx.saving,
              disabled: !_ctx.pdfPreviewUrl,
              class: "tw-h-9 tw-px-5 tw-bg-blue-600 tw-text-white tw-rounded-xl tw-text-[10px] tw-font-black tw-uppercase tw-tracking-wider hover:tw-bg-blue-700 disabled:tw-opacity-50 tw-flex tw-items-center tw-gap-2"
            }, {
              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                _createTextVNode(" Save ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "loading", "disabled"]),
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close'))),
              class: "tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-text-slate-400 hover:tw-text-red-500 tw-transition-colors"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "xmark",
                class: "tw-text-lg"
              })
            ])
          ])
        ]),
        _createElementVNode("main", _hoisted_17, [
          _createElementVNode("aside", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h2", _hoisted_20, [
                _cache[55] || (_cache[55] = _createTextVNode(" Current template: ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.currentTemplate?.name || 'None'), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toggleShowCompanyTemplateChooser())),
                class: "tw-ml-2 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-bg-blue-600 tw-text-white tw-rounded-lg hover:tw-bg-blue-700 tw-transition-colors"
              }, _toDisplayString(_ctx.isShowCompanyTemplateChooser ? 'Hide Templates' : (!_ctx.currentTemplate ? 'Choose Template':'Change Template')), 1),
              _createElementVNode("button", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toggleShowTemplateUploader())),
                class: "tw-ml-2 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-bg-blue-600 tw-text-white tw-rounded-lg hover:tw-bg-blue-700 tw-transition-colors"
              }, _toDisplayString(_ctx.isShowTemplateUploader ? 'Hide Add New' : 'Add New'), 1),
              (_ctx.currentTemplate && _ctx.templates.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleShowTemplateFieldsCopy())),
                    class: "tw-ml-2 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-bg-blue-600 tw-text-white tw-rounded-lg hover:tw-bg-blue-700 tw-transition-colors"
                  }, _toDisplayString(_ctx.isShowTemplateFieldsCopy ? 'Hide Copy' : 'Copy from Template'), 1))
                : _createCommentVNode("", true),
              (_ctx.isShowCompanyTemplateChooser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("button", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggleShowCompanyTemplateChooser())),
                      class: "tw-absolute tw-top-2 tw-right-2 tw-ml-2 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-bg-grey-200 tw-rounded-lg hover:tw-bg-grey-800 tw-transition-colors"
                    }, " X "),
                    _cache[59] || (_cache[59] = _createElementVNode("h3", { class: "tw-text-[11px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-widest tw-mb-5" }, " Choose a template from the Company Template Library ", -1)),
                    _createElementVNode("div", _hoisted_22, [
                      (_ctx.loadingTemplates)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "circle-notch",
                              spin: "",
                              class: "tw-text-slate-300"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (tpl) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: tpl.id,
                                onClick: ($event: any) => (_ctx.selectLibraryTemplate(tpl)),
                                class: _normalizeClass(['tw-group tw-flex tw-items-center tw-gap-4 tw-p-3.5 tw-rounded-2xl tw-cursor-pointer tw-transition-all tw-border',
                  _ctx.currentTemplate?.id === tpl.id
                    ? 'tw-bg-white tw-border-slate-900 tw-shadow-md'
                    : 'tw-bg-white tw-border-slate-200 hover:tw-shadow-sm hover:tw-border-slate-300'])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(['tw-w-10 tw-h-10 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-shrink-0',
                    _ctx.currentTemplate?.id === tpl.id ? 'tw-bg-slate-900 tw-text-white' : 'tw-bg-slate-50 tw-text-slate-400'])
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "file-pdf" })
                                ], 2),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("p", _hoisted_28, _toDisplayString(tpl.name), 1),
                                    (tpl.isDefault)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                          _createVNode(_component_font_awesome_icon, {
                                            icon: "star",
                                            class: "tw-text-blue-600 tw-text-[7px]"
                                          }),
                                          _cache[56] || (_cache[56] = _createElementVNode("span", { class: "tw-text-[8px] tw-font-black tw-text-blue-600 tw-uppercase tw-tracking-wider" }, " Default ", -1))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(tpl.modelType), 1),
                                    (tpl.id === _ctx.currentTemplate?.id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _cache[57] || (_cache[57] = _createElementVNode("span", { class: "tw-w-1 tw-h-1 tw-bg-slate-300 tw-rounded-full" }, null, -1)),
                                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "tw-text-[9px] tw-text-slate-400 tw-font-medium tw-leading-none" }, " Active Template ", -1))
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.handleDeleteTemplate($event, tpl)),
                                  class: "tw-opacity-0 group-hover:tw-opacity-100 tw-p-2 tw-text-slate-300 hover:tw-text-red-500 tw-transition-all tw-shrink-0"
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "trash",
                                    size: "sm"
                                  })
                                ], 8, _hoisted_32)
                              ], 10, _hoisted_25))
                            }), 128))
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isShowTemplateUploader)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("button", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleShowTemplateUploader())),
                      class: "tw-absolute tw-top-2 tw-right-2 tw-ml-2 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-bg-grey-200 tw-rounded-lg hover:tw-bg-grey-800 tw-transition-colors"
                    }, " X "),
                    _cache[61] || (_cache[61] = _createElementVNode("h3", { class: "tw-text-[11px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-widest tw-mb-5" }, " Upload Template ", -1)),
                    _createVNode(_component_InputField, {
                      modelValue: _ctx.newTemplateName,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newTemplateName) = $event)),
                      placeholder: "Template Name",
                      label: "Name"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_DropdownList, {
                      modelValue: _ctx.newModelType,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newModelType) = $event)),
                      options: ['TRIP', 'ORDER', 'DRIVER', 'BL'],
                      label: "Data Context"
                    }, null, 8, ["modelValue"]),
                    _cache[62] || (_cache[62] = _createElementVNode("p", { class: "tw-text-[10px] tw-leading-snug tw-text-slate-500" }, " TRIP = dispatch/trip data. ORDER = delivery order data. DRIVER = driver profile data. BL = bill of lading. ", -1)),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("input", {
                        type: "file",
                        accept: "application/pdf",
                        class: "tw-absolute tw-inset-0 tw-opacity-0 tw-cursor-pointer tw-z-10",
                        onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                      }, null, 32),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.selectedFile ? 'file-circle-check' : 'cloud-arrow-up',
                          class: _normalizeClass(_ctx.selectedFile ? 'tw-text-green-500' : 'tw-text-slate-400'),
                          size: "lg"
                        }, null, 8, ["icon", "class"]),
                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.selectedFile ? _ctx.selectedFile.name : 'Select PDF Template'), 1)
                      ])
                    ]),
                    _createVNode(_component_Button, {
                      onClick: _ctx.handleUpload,
                      loading: _ctx.uploading,
                      disabled: !_ctx.canUpload,
                      class: "tw-w-full tw-h-11 tw-bg-slate-900 tw-text-white tw-rounded-xl tw-text-[11px] tw-font-black tw-uppercase tw-tracking-widest hover:tw-bg-slate-800 tw-transition-all tw-flex tw-items-center tw-justify-center tw-gap-3 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-shadow-sm"
                    }, {
                      default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                        _createTextVNode(" Upload Template ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading", "disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isShowTemplateFieldsCopy && _ctx.currentTemplate && _ctx.templates.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _cache[63] || (_cache[63] = _createElementVNode("h3", { class: "tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-widest" }, " Copy Fields from Another Template ", -1)),
                  _cache[64] || (_cache[64] = _createElementVNode("p", { class: "tw-text-[10px] tw-leading-snug tw-text-slate-500 tw-mb-2 tw-whitespace-normal" }, " Copy template fields positions from another template into the current template (and overwrite any existing positions). ", -1)),
                  _createVNode(_component_DropdownList, {
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleCopyTemplateFields($event))),
                    label: 'label',
                    placeholder: 'Select a template',
                    options: _ctx.templates
              .filter(t => t.modelType === _ctx.currentTemplate.modelType && Number(t.id) !== Number(_ctx.currentTemplate.id))
              .map(t => ({ value: t.id, label: t.name }))
                  }, null, 8, ["options"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentTemplate && _ctx.templates.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _cache[65] || (_cache[65] = _createElementVNode("h3", { class: "tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-widest" }, " Add Data Fields ", -1)),
                    _createElementVNode("span", {
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.undo())),
                      class: "tw-cursor-pointer",
                      "aria-label": "Undo",
                      title: "Und"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-arrow-rotate-back" })
                    ]),
                    _createElementVNode("span", {
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.redo())),
                      class: "tw-cursor-pointer",
                      "aria-label": "Redo",
                      title: "Redo"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-arrow-rotate-forward" })
                    ]),
                    _createElementVNode("span", {
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.exportPlacedFieldsToJson())),
                      class: "tw-cursor-pointer",
                      title: "export",
                      "aria-label": "Export placed fields as JSON"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-arrow-up-from-bracket" })
                    ]),
                    _createElementVNode("span", {
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.importPlacedFieldsJson())),
                      class: "tw-cursor-pointer",
                      title: "import",
                      "aria-label": "Import placed fields from JSON"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-arrow-up-from-bracket",
                        style: {"transform":"rotate(180deg)"}
                      })
                    ]),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.filteredKeys.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_SearchInput, {
                      modelValue: _ctx.searchQuery,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.searchQuery) = $event)),
                      placeholder: "Search fields (e.g. driver, order...)",
                      class: "tw-w-full"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredKeys, (key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          onClick: ($event: any) => (_ctx.selectFieldKey(key)),
                          draggable: "true",
                          onDragstart: ($event: any) => (_ctx.onSidebarDragStart(key, $event)),
                          class: _normalizeClass(['tw-px-4 tw-py-3 tw-rounded-xl tw-text-xs tw-font-semibold tw-cursor-grab active:tw-cursor-grabbing tw-border tw-transition-all',
                  key === 'static.text' ? 'tw-bg-emerald-50 tw-border-emerald-200 tw-text-emerald-700 tw-mb-4' : '',
                  key === 'custom.*' ? 'tw-bg-purple-50 tw-border-purple-200 tw-text-purple-700' : '',
                  _ctx.activeKey === key && key !== 'static.text' && key !== 'custom.*' ? 'tw-bg-white tw-border-blue-600 tw-text-blue-600 tw-shadow-sm' : '',
                  _ctx.activeKey === key && key === 'static.text' ? 'tw-border-emerald-600 tw-shadow-sm' : '',
                  _ctx.activeKey === key && key === 'custom.*' ? 'tw-border-purple-600 tw-shadow-sm' : '',
                  _ctx.activeKey !== key && key !== 'static.text' && key !== 'custom.*' ? 'tw-bg-white tw-border-slate-200 tw-text-slate-700 hover:tw-border-slate-300' : ''])
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "grip-vertical",
                            class: "tw-mr-3 tw-opacity-30"
                          }),
                          _createTextVNode(" " + _toDisplayString(key), 1)
                        ], 42, _hoisted_44))
                      }), 128)),
                      (_ctx.filteredKeys.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [...(_cache[66] || (_cache[66] = [
                            _createElementVNode("p", { class: "tw-text-[10px] tw-text-slate-400 tw-italic" }, "No fields found", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_46, [
            (!_ctx.pdfPreviewUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "file-pdf",
                      class: "tw-text-slate-200 tw-text-4xl"
                    })
                  ]),
                  _cache[67] || (_cache[67] = _createElementVNode("h4", { class: "tw-text-xl tw-font-bold tw-text-slate-900" }, "Ready to edit?", -1)),
                  _cache[68] || (_cache[68] = _createElementVNode("p", { class: "tw-text-sm tw-text-slate-500 tw-mt-2 tw-max-w-xs tw-mx-auto" }, " Select a template from your library or upload a new one to start mapping your fields. ", -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  (_ctx.isPdfLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [...(_cache[69] || (_cache[69] = [
                        _createElementVNode("div", { "uk-spinner": "" }, "Loading...", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "tw-relative tw-shadow-2xl tw-shadow-slate-900/10 tw-bg-white tw-rounded-sm tw-mt-0 tw-mb-32",
                    style: _normalizeStyle(_ctx.canvasWrapperStyle),
                    ref: "pdfContainer",
                    onMousedown: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.handleCanvasClick && _ctx.handleCanvasClick(...args))),
                    onMousemove: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.onDrag && _ctx.onDrag(...args))),
                    onMouseup: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.stopDrag && _ctx.stopDrag(...args))),
                    onMouseleave: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.stopDrag && _ctx.stopDrag(...args))),
                    onDragover: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["prevent"])),
                    onDrop: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.onSidebarDrop && _ctx.onSidebarDrop(...args)))
                  }, [
                    _createElementVNode("canvas", _hoisted_51, null, 512),
                    (_ctx.showGrid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placedFields, (field, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        (field.page === _ctx.currentPage)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onMousedown: _withModifiers(($event: any) => (_ctx.startDrag(index, $event)), ["stop"]),
                              onClick: _withModifiers(($event: any) => (_ctx.selectField(index)), ["stop"]),
                              class: _normalizeClass(['tw-absolute tw-cursor-move tw-group tw-select-none',
                  _ctx.selectedFieldIndex === index ? 'tw-ring-2 tw-ring-offset-2 tw-ring-blue-500 tw-rounded-lg' : '']),
                              style: _normalizeStyle({
                    left: (field.x * 100) + '%',
                    top: (field.y * 100) + '%',
                    fontSize: 'clamp(8px, 1.1cqi, 14px)',
                    transform: 'translateY(-100%)',
                    zIndex: _ctx.selectedFieldIndex === index ? 50 : 20
                  })
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([
                    'tw-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-1 tw-rounded-lg tw-shadow-lg tw-transition-colors',
                    _ctx.resolvedFieldType(field) === 'static' ? 'tw-bg-emerald-600 tw-text-white' : '',
                    _ctx.resolvedFieldType(field) === 'dynamic' ? 'tw-bg-blue-600 tw-text-white' : '',
                    _ctx.resolvedFieldType(field) === 'user_prompt' ? 'tw-bg-purple-600 tw-text-white' : ''
                  ])
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: _ctx.resolvedFieldType(field) === 'static' ? 'font' : (_ctx.resolvedFieldType(field) === 'user_prompt' ? 'keyboard' : 'database'),
                                  class: "tw-text-[10px] tw-opacity-70"
                                }, null, 8, ["icon"]),
                                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.resolvedFieldType(field) === 'static'
                          ? (field.static_value || 'Empty Text')
                          : (_ctx.resolvedFieldType(field) === 'user_prompt'
                            ? _ctx.getPromptDisplayLabel(field)
                            : field.field_key)), 1),
                                _createElementVNode("button", {
                                  onClick: _withModifiers(($event: any) => (_ctx.removeField(index)), ["stop"]),
                                  class: "hover:tw-text-red-200 tw-ml-1"
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "xmark" })
                                ], 8, _hoisted_55)
                              ], 2)
                            ], 46, _hoisted_53))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createVNode(_Transition, { name: "fade-slide" }, {
                      default: _withCtx(() => [
                        (_ctx.selectedFieldIndex !== null && !_ctx.isDragging)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "tw-fixed tw-bottom-10 tw-left-1/2 tw-transform tw--translate-x-1/2 tw-z-[70] tw-w-max tw-max-w-[90vw] tw-bg-white/80 tw-backdrop-blur-xl tw-rounded-3xl tw-shadow-[0_20px_50px_rgba(0,0,0,0.1)] tw-border tw-border-slate-200/50 tw-p-3 tw-flex tw-items-center tw-gap-5 tw-pointer-events-auto",
                              onMousedown: _cache[37] || (_cache[37] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("div", _hoisted_56, [
                                _cache[70] || (_cache[70] = _createElementVNode("p", { class: "tw-text-[9px] tw-font-black tw-text-slate-400 tw-uppercase tw-tracking-[0.15em]" }, "Field", -1)),
                                _createElementVNode("p", _hoisted_57, _toDisplayString(_ctx.placedFields[_ctx.selectedFieldIndex].field_key), 1)
                              ]),
                              (_ctx.resolvedFieldType(_ctx.placedFields[_ctx.selectedFieldIndex]) === 'static')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.placedFields[_ctx.selectedFieldIndex].static_value) = $event)),
                                      placeholder: "Text...",
                                      class: "tw-w-32 tw-px-3 tw-py-2 tw-bg-slate-100 tw-rounded-xl tw-text-xs tw-font-bold tw-outline-none"
                                    }, null, 512), [
                                      [_vModelText, _ctx.placedFields[_ctx.selectedFieldIndex].static_value]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.resolvedFieldType(_ctx.placedFields[_ctx.selectedFieldIndex]) === 'user_prompt')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _cache[71] || (_cache[71] = _createElementVNode("label", { class: "tw-text-[10px] tw-font-bold tw-text-slate-500" }, "Label", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.placedFields[_ctx.selectedFieldIndex].prompt_label) = $event)),
                                      onBlur: _cache[28] || (_cache[28] = ($event: any) => (_ctx.syncPromptFieldKeyFromLabel(_ctx.selectedFieldIndex))),
                                      placeholder: "My Date Field",
                                      class: "tw-w-40 tw-px-2 tw-py-1 tw-bg-slate-100 tw-rounded-lg tw-text-[11px] tw-font-semibold tw-outline-none"
                                    }, null, 544), [
                                      [_vModelText, _ctx.placedFields[_ctx.selectedFieldIndex].prompt_label]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_60, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "range",
                                  min: "6",
                                  max: "36",
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.placedFields[_ctx.selectedFieldIndex].font_size) = $event)),
                                  class: "tw-w-24 accent-slate-900"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.placedFields[_ctx.selectedFieldIndex].font_size,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  min: "6",
                                  max: "36",
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.placedFields[_ctx.selectedFieldIndex].font_size) = $event)),
                                  onKeydown: _cache[31] || (_cache[31] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.normalizeSelectedFieldFontSize && _ctx.normalizeSelectedFieldFontSize(...args)), ["prevent"]), ["enter"])),
                                  onBlur: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.normalizeSelectedFieldFontSize && _ctx.normalizeSelectedFieldFontSize(...args))),
                                  class: "tw-w-14 tw-px-2 tw-py-1 tw-bg-slate-100 tw-rounded-lg tw-text-[11px] tw-font-semibold tw-outline-none"
                                }, null, 544), [
                                  [
                                    _vModelText,
                                    _ctx.placedFields[_ctx.selectedFieldIndex].font_size,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _cache[72] || (_cache[72] = _createElementVNode("span", { class: "tw-text-[10px] tw-font-bold tw-text-slate-500" }, "px", -1))
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _cache[73] || (_cache[73] = _createElementVNode("label", { class: "tw-text-[10px] tw-font-bold tw-text-slate-500" }, "Max Chars", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  min: "1",
                                  placeholder: "-",
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.placedFields[_ctx.selectedFieldIndex].max_chars_per_line) = $event)),
                                  class: "tw-w-16 tw-px-2 tw-py-1 tw-bg-slate-100 tw-rounded-lg tw-text-[11px] tw-font-semibold tw-outline-none"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.placedFields[_ctx.selectedFieldIndex].max_chars_per_line,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _cache[74] || (_cache[74] = _createElementVNode("label", { class: "tw-text-[10px] tw-font-bold tw-text-slate-500" }, "Max Lines", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  min: "1",
                                  placeholder: "-",
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.placedFields[_ctx.selectedFieldIndex].max_lines) = $event)),
                                  class: "tw-w-14 tw-px-2 tw-py-1 tw-bg-slate-100 tw-rounded-lg tw-text-[11px] tw-font-semibold tw-outline-none"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.placedFields[_ctx.selectedFieldIndex].max_lines,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("button", {
                                onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.placedFields[_ctx.selectedFieldIndex].is_bold = !_ctx.placedFields[_ctx.selectedFieldIndex].is_bold)),
                                class: _normalizeClass([_ctx.placedFields[_ctx.selectedFieldIndex].is_bold ? 'tw-bg-slate-900 tw-text-white' : 'tw-text-slate-400', 'tw-w-8 tw-h-8 tw-rounded-lg tw-transition-all'])
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "bold" })
                              ], 2),
                              _createElementVNode("button", {
                                onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.selectedFieldIndex = null)),
                                class: "tw-text-slate-300 hover:tw-text-slate-900"
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "xmark" })
                              ])
                            ], 32))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ], 36),
                  (_ctx.numPages > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("button", {
                            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.changePage(-1))),
                            disabled: _ctx.currentPage === 1,
                            class: "tw-p-1 tw-w-7 tw-h-7 tw-flex tw-items-center tw-justify-center hover:tw-bg-slate-100 tw-rounded-lg disabled:tw-opacity-30 tw-transition-colors"
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
                          ], 8, _hoisted_65),
                          _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.numPages), 1),
                          _createElementVNode("button", {
                            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.changePage(1))),
                            disabled: _ctx.currentPage === _ctx.numPages,
                            class: "tw-p-1 tw-w-7 tw-h-7 tw-flex tw-items-center tw-justify-center hover:tw-bg-slate-100 tw-rounded-lg disabled:tw-opacity-30 tw-transition-colors"
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
                          ], 8, _hoisted_67)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}